import { BasicDialogProperties } from "../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2AddFriendDialogProperties extends BasicDialogProperties {
    public playerName: string;
    public playerId: number = 0;

    constructor(playerName: string, playerId: number) {
        super();

        this.playerName = playerName;
        this.playerId = playerId;
    }
}
